import React, {
  ReactElement,
  useEffect,
  useState
} from 'react'
import { Layout, Skeleton, Menu } from 'antd'
import classNames from 'classnames'
import CustomScroll from 'react-custom-scroll'
import { NEW_SYSTEM_BASE_PATH } from '../config'
import {
  setTitleInfo,
  setIconInfo
} from '@/components/layout/mendian/sidemenu/utlils'
import 'react-custom-scroll/dist/customScroll.css'
import styles from './sidemenu.module.less'
import { Link } from 'react-router-dom'
import { getMenu } from '@/services/api'
import { MenuNode } from '@/services/api.d'

const theme = location.hostname === 'yfyk.youfangyouke.com' ? 'dark' : 'light'

const fixMenuError = (menus: MenuNode[]) => {
  const host = `//${location.host}`
  menus.forEach(menu => {
    // 空格处理
    if (typeof menu.link === 'string') {
      menu.link = menu.link.trim()
      // 全地址处理
      if (menu.link.includes(host)) {
        menu.link = menu.link.replace(host, '')
        menu.link = menu.link.substring(menu.link.indexOf('/'))
      }
    }
    if (Array.isArray(menu.sublist) && menu.sublist.length) {
      fixMenuError(menu.sublist)
      const link = `m${menu.id}m`
      if (menu.link !== link) menu.link = link
    }
  })

  // 排除: 不存在子节点的父节点
  menus = menus.filter(x => !(
    x.type === 1 &&
    x.link === `m${x.id}m` &&
    (!Array.isArray(x.sublist) || x.sublist.length === 0)
  ))
}

const useMenus = () => {
  const [menus, setMenus] = useState<MenuNode[]>([])
  const [rootSubMenuKeys, setRootSubMenuKeys] = useState<string[]>([])
  // region path -> path key 的快速所有，方便获取所在分支的所有菜单的key用来做open状态管理
  const [pathKeyMap, setPathKeyMap] = useState<{ [path: string]: string[] }>(
    {}
  )
  const [titleMap, setTitleMap] = useState<{ [path: string]: string }>({})
  const pathKeyHash: { [path: string]: string[] } = {}
  const tmpTitleMap: { [path: string]: string } = {}
  const currentKeyArr: string[] = []
  const getMenuKeyFromPath = (menus: MenuNode[]) => {
    menus.forEach(menu => {
      if (menu.link === `m${menu.id}m`) {
        currentKeyArr.push(menu.link)
        if (Array.isArray(menu.sublist) && menu.sublist.length) {
          getMenuKeyFromPath(menu.sublist)
        }
      } else {
        pathKeyHash[getPathName(menu.link)] = currentKeyArr.concat([
          getPathName(menu.link)
        ])
        tmpTitleMap[menu.link] = menu.title
      }
    })
    currentKeyArr.pop()
  }
  // endregion

  useEffect(() => {
    getMenu().then(res => {
      const { entrances = [] } = res?.data || []
      fixMenuError(entrances)
      setMenus(entrances)
      setRootSubMenuKeys(entrances.map((entry: any) => entry.link))
      getMenuKeyFromPath(entrances)
      setPathKeyMap(pathKeyHash)
      setTitleMap(tmpTitleMap)
    })
  }, [])
  return {
    menus,
    rootSubMenuKeys,
    pathKeyMap,
    titleMap
  }
}

/**
 * 获取pathname部分
 * @param link
 * @returns
 */
const getPathName = (link: string) => {
  return link.split('?')[0]
}

const iconFontClass = classNames('iconfont', styles.menuIcon)
const iconFontWbClass = classNames('iconfont-wb', styles.menuIcon)
/**
 * 判断是否是属于新系统的链接
 * @param entry
 */
const isLinkInNewSystem = (entry: MenuNode) =>
  entry.link && entry.link.includes(`/${NEW_SYSTEM_BASE_PATH}/`)
/**
 * 新系统的链接跳转到solar的路由中
 * @param entry
 */
const getCorrectLink = (entry: MenuNode) => {
  if (isLinkInNewSystem(entry) && !entry.link.includes('/solar')) {
    return entry.link.replace(`/${NEW_SYSTEM_BASE_PATH}`, '/solar/metis')
  }
  return entry.link
}

/**
 * 解析icon，适配iconfont以及58iconfont
 * @param icon
 */
const parseIcon = (icon: string | undefined): { iconString: string; isWb: boolean } => {
  if (!icon) return { iconString: '', isWb: false }
  const isWbIcon = icon.indexOf('wb_') === 0
  return {
    iconString: isWbIcon ? icon.slice(3) : icon,
    isWb: isWbIcon
  }
}

/**
 * 获取菜单组件
 * @param entry
 */
const getMenuNodes = (entry: MenuNode) => {
  const handleClick = (link: string) => {
    window.loggerAction?.sendnpv?.({
      action: 'left_menu_click',
      ep: { link }
    })
  }

  const iconParse = parseIcon(entry.icon)

  if (Array.isArray(entry.sublist)) {
    const title = (
      <>
        {entry.icon && (
          <span
            className={iconParse.isWb ? iconFontWbClass : iconFontClass}
            dangerouslySetInnerHTML={{ __html: iconParse.iconString }}
          />
        )}
        <span className={styles.title}>{entry.title}</span>
      </>
    )
    const subMenus = entry.sublist.map(subNode => getMenuNodes(subNode))
    return (
      <Menu.SubMenu key={entry.link} title={title}>
        {subMenus}
      </Menu.SubMenu>
    )
  } else {
    return (
      <Menu.Item key={getPathName(entry.link)} active>
        {entry.icon && (
          <span
            className={iconParse.isWb ? iconFontWbClass : iconFontClass}
            dangerouslySetInnerHTML={{ __html: iconParse.iconString }}
          />
        )}
        {isLinkInNewSystem(entry)
          ? (
          <Link onClick={() => handleClick(entry.link)} to={getCorrectLink(entry)}>
            <span className={styles.title}>{entry.title}</span>
          </Link>
            )
          : (
          <a
            href={entry.link}
            className={styles.title}
            onClick={() => handleClick(entry.link)}
            target={entry.target === 1 ? '_blank' : '_self'} rel="noreferrer"
          >
            {entry.title}
          </a>
            )}
      </Menu.Item>
    )
  }
}

interface SideMenuProps {
  className?: string;
}

const MetisSideMenu = (props: SideMenuProps) => {
  const { className } = props
  const { menus, rootSubMenuKeys = [], pathKeyMap, titleMap } = useMenus()
  const [openKeys, setOpenKeys] = React.useState<string[]>([])
  const [selectedKeys, setSelectedKeys] = React.useState<string[]>([])
  useEffect(() => {
    // 路由变化时更新菜单展开和选中状态
    if (menus.length > 0 && location.pathname) {
      const pathname = location.pathname.replace(
        '/solar/metis',
        '/metis'
      )
      const currentOpenedPath = pathKeyMap[pathname]
      const routerPath = pathname
      setOpenKeys(currentOpenedPath)
      setSelectedKeys([routerPath])
      setTitleInfo(titleMap[routerPath])
    }
  }, [location, pathKeyMap, menus, titleMap])
  useEffect(() => {
    setIconInfo()
  }, [])

  const onOpenChange = (keys: string[]) => {
    // 同时只有一个菜单展开
    const currentOpenKeys = openKeys || []
    const latestOpenKey = keys.find(key => currentOpenKeys.indexOf(key) === -1)
    if (
      typeof latestOpenKey === 'undefined' ||
      rootSubMenuKeys.indexOf(latestOpenKey) === -1
    ) {
      setOpenKeys(keys)
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : [])
    }
  }
  const onSelectedChange = (key: string) => {
    setSelectedKeys([getPathName(key)])
  }

  const nodes: ReactElement[] = []
  menus.forEach(entry => {
    nodes.push(getMenuNodes(entry))
  })

  const mergeClass = classNames(styles.container, className)
  return (
    <Layout.Sider theme={theme} width={190} className={mergeClass}>
      <Skeleton
        title={false}
        paragraph={{ rows: 22 }}
        active
        loading={menus.length === 0}
      >
        <CustomScroll heightRelativeToParent="calc(100vh - 69px)">
          <Menu
            mode={'inline'}
            theme={theme}
            siderCollapsed={false}
            className={styles.menuRoot}
            openKeys={openKeys}
            onOpenChange={keys => onOpenChange(keys as string[])}
            selectedKeys={selectedKeys}
            onSelect={info => onSelectedChange(info.key as string)}
          >
            {nodes}
          </Menu>
        </CustomScroll>
      </Skeleton>
    </Layout.Sider>
  )
}

export { MetisSideMenu }
